/**
 * TanStack Query (Vue Query) Configuration
 */
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query';
import type { App } from 'vue';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: 1,
      refetchOnWindowFocus: import.meta.env.PROD,
      refetchOnReconnect: true,
      refetchOnMount: true,
    },
    mutations: {
      retry: 1,
    },
  },
});

export function setupVueQuery(app: App) {
  app.use(VueQueryPlugin, {
    queryClient,
    enableDevtoolsV6Plugin: true,
  });

  return queryClient;
}

export { queryClient };
